var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.getters.isOturum)?_c('Index'):_vm._e(),_vm._v(" "),(!this.$store.getters.isOturum && this.$route.path=='/giris')?_c('Giris'):_vm._e(),_vm._v(" "),(!this.$store.getters.isOturum && this.$route.path=='/kayit')?_c('Kayit'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e555c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 152
// module chunks = 0